/* ==========================================================================
   カート内 年齢確認（20歳以上）
   - 生年月日(年/月/日プルダウン) + 確認チェックが揃うまでチェックアウトをブロック
   - 判定は常に画面の実入力から行う（古い確認済みを残さない）
   - カートの商品構成が変わったらチェックを外し再確認を強制
   - 年齢確認UIが無いページ(/cart 等)には自動生成して挿入
   - ブロック用CSSは custom.css の body.cart-age-unconfirmed 側で定義
   ※ Horizonテーマはカートドロワーを動的挿入するため、本スクリプトは
     スニペット内インラインではなく theme.liquid からグローバル読み込みする
   ========================================================================== */
(function () {
  if (window.__cartAgeCheckReady) return;
  window.__cartAgeCheckReady = true;

  var MIN_AGE = 20;
  var ATTR_DOB = '生年月日';
  var ATTR_OK  = '年齢確認';
  var OK_VALUE = '20歳以上 確認済み';

  var CHECKOUT_SEL =
    '#checkout, [name="checkout"], button[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"],' +
    ' .cart__checkout-button, .cart-summary__checkout,' +
    ' .additional-checkout-buttons, .shopify-payment-button,' +
    ' shopify-accelerated-checkout, shopify-accelerated-checkout-cart,' +
    ' [data-shopify="dynamic-checkout-cart"]';

  /* 画面の実入力のミラー（判定は常にここを readUI で同期してから行う） */
  var current = { y: '', m: '', d: '', ok: false };

  function ui() { return document.querySelector('.cart-agecheck'); }
  function q(cls) { var u = ui(); return u ? u.querySelector(cls) : null; }
  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }

  function readUI() {
    var y = q('.cart-agecheck__y'), m = q('.cart-agecheck__m'), d = q('.cart-agecheck__d'), o = q('.cart-agecheck__ok');
    current.y = y ? y.value : '';
    current.m = m ? m.value : '';
    current.d = d ? d.value : '';
    current.ok = o ? o.checked : false;
  }

  function dobVal() {
    if (!current.y || !current.m || !current.d) return '';
    return current.y + '-' + pad(current.m) + '-' + pad(current.d);
  }
  function calcAge(s) {
    if (!s) return null;
    var p = s.split('-');
    if (p.length < 3) return null;
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    if (isNaN(d.getTime())) return null;
    var t = new Date();
    var a = t.getFullYear() - d.getFullYear();
    var mm = t.getMonth() - d.getMonth();
    if (mm < 0 || (mm === 0 && t.getDate() < d.getDate())) a--;
    return a;
  }
  function isUnder() { var a = calcAge(dobVal()); return dobVal() !== '' && a !== null && a < MIN_AGE; }
  function confirmed() { var a = calcAge(dobVal()); return !!(dobVal() && a !== null && a >= MIN_AGE && current.ok); }

  function applyGate() {
    // 常に画面の実際の入力から判定。UIが無い時は未確認扱い（古い確認済みを残さない）
    if (ui()) { readUI(); }
    else { current = { y: '', m: '', d: '', ok: false }; }
    var ok = confirmed();
    // body クラスで一括ブロック（再描画後の新ボタン・iframe決済ボタンにも即座にCSSが効く）
    document.body.classList.toggle('cart-age-unconfirmed', !ok);
    document.querySelectorAll(CHECKOUT_SEL).forEach(function (el) {
      if (el.tagName === 'BUTTON') el.disabled = !ok;
      el.setAttribute('aria-disabled', String(!ok));
    });
    var err = q('.cart-agecheck__error');
    if (err) err.hidden = !isUnder();
  }

  var saveTimer = null;
  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var attrs = {};
      attrs[ATTR_DOB] = dobVal() || '';
      attrs[ATTR_OK] = confirmed() ? OK_VALUE : '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }, 400);
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.cart-agecheck')) {
      readUI();
      if (isUnder()) { current.ok = false; var o = q('.cart-agecheck__ok'); if (o) o.checked = false; }
      applyGate();
      save();
    }
  });

  /* カートの中身（商品構成）が変わったら確認チェックを外し、再確認を強制する。
     ※ 属性保存(/cart/update)では item_count/items は変わらないので誤って外れない。
     これにより「入れる→削除→また入れる」でも年齢確認が必須に戻る。 */
  var lastItemSig = null;
  var sigFetching = false;
  function uncheck() {
    current.ok = false;
    var o = q('.cart-agecheck__ok'); if (o) o.checked = false;
  }
  function refreshCartSig() {
    if (sigFetching) return;
    sigFetching = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = (c.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join(',');
        var sig = (c.item_count || 0) + '|' + items;
        if (lastItemSig !== null && sig !== lastItemSig) {
          uncheck(); // 商品構成が変わった → 再確認させる
        }
        lastItemSig = sig;
        applyGate();
      })
      .catch(function () {})
      .then(function () { sigFetching = false; });
  }

  function openCartDrawer() {
    // テーマ共通のカートドロワー開放を試みる
    var triggers = [
      '[data-action="toggle-cart"]',
      '[data-cart-toggle]',
      '[data-cart-open]',
      '[aria-controls="CartDrawer"]',
      '[aria-controls="cart-drawer"]',
      '#cart-icon-bubble',
      '.cart-count-bubble'
    ];
    for (var i = 0; i < triggers.length; i++) {
      var el = document.querySelector(triggers[i]);
      if (el) { el.click(); return; }
    }
    // カスタムイベントで試みる
    ['cart:open','cart:toggle','cart-drawer:open'].forEach(function(ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
  }

  document.addEventListener('click', function (e) {
    if (confirmed()) return;
    if (!e.target.closest) return;
    if (e.target.closest(CHECKOUT_SEL)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var u = ui();
      // カートドロワーが非表示の場合は開く
      if (!u || u.closest('[hidden]') || u.closest('[aria-hidden="true"]') ||
          getComputedStyle(u.closest('.cart-drawer, #CartDrawer, [id*="cart"]') || document.body).display === 'none') {
        openCartDrawer();
        setTimeout(function () {
          var u2 = ui();
          if (u2) {
            u2.classList.add('cart-agecheck--shake');
            var f = u2.querySelector('.cart-agecheck__y');
            if (f) f.focus();
          }
        }, 400);
        return;
      }
      u.classList.remove('cart-agecheck--shake');
      void u.offsetWidth;
      u.classList.add('cart-agecheck--shake');
      var f = u.querySelector('.cart-agecheck__y');
      if (f) f.focus();
    }
  }, true);

  /* 再描画されたら判定し直す。確認状態は画面の実入力からのみ判定するため、
     カート変更で入力欄がリセットされれば自動的に未確認＝チェックアウト無効に戻る */
  var moTimer = null;
  var mo = new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(function () {
      ensureUI();         // UIが消えたページ(/cart 等)には再挿入
      buildYearOptions(); // 再描画後も年リストを再生成
      refreshCartSig();   // 商品構成が変わっていたらチェックを外す（applyGateも内部で実行）
      applyGate();        // 実入力から判定（古い確認済みは書き戻さない）
      customizeCart();    // ボタン文言の変更・関税表記の非表示（再描画後も維持）
      ensureViewCartButton(); // 商品ページに「カートを確認する」ボタンを注入
    }, 120);
  });

  /* カート表示のカスタマイズ
     ① チェックアウトボタンの文言を「ご購入手続きへ」に変更
        （「チェックアウト」だと決済完了の誤解を与えるため）
     ② 「関税と税金が含まれます…」の注記を非表示 */
  function customizeCart() {
    // ① ボタン文言の置換（ボタン内のテキストノードのみ書き換え、アイコン等は保持）
    document.querySelectorAll('#checkout, [name="checkout"], .cart__checkout-button').forEach(function (btn) {
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.indexOf('チェックアウト') !== -1) {
          node.nodeValue = node.nodeValue.replace('チェックアウト', 'ご購入手続きへ');
        }
      }
      if (btn.getAttribute('value') && btn.getAttribute('value').indexOf('チェックアウト') !== -1) {
        btn.setAttribute('value', btn.getAttribute('value').replace('チェックアウト', 'ご購入手続きへ'));
      }
    });

    // ② 関税・税金の注記を非表示（その文を含む末端要素を隠す）
    var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var t;
    while ((t = tw.nextNode())) {
      if (t.nodeValue && t.nodeValue.indexOf('関税') !== -1 && t.nodeValue.indexOf('税金') !== -1) {
        if (t.parentElement) { t.parentElement.style.display = 'none'; }
      }
    }
  }

  /* 商品ページ：「カートに追加する」の直下に「カートを確認する」ボタン(/cart)を注入 */
  function ensureViewCartButton() {
    var scope = document.querySelector('.product-information') || document;
    var atc = null;
    var cands = scope.querySelectorAll('.add-to-cart-button, button[name="add"]');
    for (var i = 0; i < cands.length; i++) {
      if (cands[i].closest('sticky-add-to-cart')) continue; // 追従バーは除外
      if (cands[i].offsetParent === null) continue;          // 非表示は除外
      atc = cands[i];
      break;
    }
    if (!atc) return;
    // 商品一覧（quick-add-component内）では挿入しない
    if (atc.closest('quick-add-component')) return;
    // 既に注入済みなら二重挿入しない
    var host = atc.parentElement;
    if (!host || host.querySelector('.banzai-view-cart')) return;
    var link = document.createElement('a');
    link.className = 'button banzai-view-cart';
    link.href = '/cart';
    link.textContent = 'カートを確認する';
    atc.insertAdjacentElement('afterend', link);
  }

  /* 年齢確認UIが無いページ（独立した /cart ページ等）には自動生成して挿入する */
  function buildMarkup() {
    var wrap = document.createElement('div');
    wrap.className = 'cart-agecheck';

    var monthOpts = '<option value="">月</option>';
    for (var m = 1; m <= 12; m++) { monthOpts += '<option value="' + m + '">' + m + '</option>'; }
    var dayOpts = '<option value="">日</option>';
    for (var dd = 1; dd <= 31; dd++) { dayOpts += '<option value="' + dd + '">' + dd + '</option>'; }

    wrap.innerHTML =
      '<p class="cart-agecheck__title">年齢確認</p>' +
      '<div class="cart-agecheck__field">' +
        '<span>生年月日を入力してください</span>' +
        '<div class="cart-agecheck__dob-selects">' +
          '<select class="cart-agecheck__y"><option value="">年</option></select>' +
          '<select class="cart-agecheck__m">' + monthOpts + '</select>' +
          '<select class="cart-agecheck__d">' + dayOpts + '</select>' +
        '</div>' +
      '</div>' +
      '<label class="cart-agecheck__check">' +
        '<input type="checkbox" class="cart-agecheck__ok">' +
        '<span>【年齢確認】20歳以上であることを確認しました。</span>' +
      '</label>' +
      '<p class="cart-agecheck__error" hidden>20歳未満の方はご購入いただけません。</p>';
    return wrap;
  }

  function ensureUI() {
    if (ui()) return;
    // ページ上のチェックアウトボタン（ドロワー内の非表示要素は除く）を探す
    var btn = null;
    var cands = document.querySelectorAll('#checkout, [name="checkout"], .cart__checkout-button, .cart-summary__checkout, a[href$="/checkout"]');
    for (var i = 0; i < cands.length; i++) {
      if (cands[i].offsetParent !== null) { btn = cands[i]; break; }
    }
    if (!btn) return;
    var node = buildMarkup();
    var anchor = btn.closest('form[action*="/cart"], .cart__ctas, .cart__footer, .cart-summary') || btn.parentElement;
    if (anchor && anchor.contains(btn)) { anchor.insertBefore(node, btn); }
    else if (btn.parentElement) { btn.parentElement.insertBefore(node, btn); }
  }

  /* 年プルダウンを「20歳以上の年だけ・新しい順」で生成（高齢の方のスクロール量を軽減） */
  function buildYearOptions() {
    var sel = q('.cart-agecheck__y');
    if (!sel || sel.getAttribute('data-built') === '1') return;
    var keep = sel.value; // 既存の選択値（あれば）を退避
    var thisYear = new Date().getFullYear();
    var maxYear = thisYear - MIN_AGE;   // ちょうど20歳になる年
    var minYear = thisYear - 100;       // 100歳まで
    var ph = sel.querySelector('option[value=""]');
    sel.innerHTML = '';
    // 先頭にプレースホルダ（「年」など）を復元
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = ph ? ph.textContent : '年';
    sel.appendChild(opt0);
    for (var y = maxYear; y >= minYear; y--) {
      var o = document.createElement('option');
      o.value = String(y);
      o.textContent = String(y);
      sel.appendChild(o);
    }
    if (keep) sel.value = keep;
    sel.setAttribute('data-built', '1');
  }

  function clearCartAttrs() {
    var attrs = {};
    attrs[ATTR_DOB] = '';
    attrs[ATTR_OK] = '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  function start() {
    clearCartAttrs(); // ページロード時に前回セッションの年齢情報をリセット
    ensureUI();       // UIが無いページ(/cart 等)には自動挿入
    buildYearOptions();
    refreshCartSig(); // 現在のカート構成を基準として記録（applyGateも内部で実行）
    applyGate();
    customizeCart();  // ボタン文言の変更・関税表記の非表示
    ensureViewCartButton(); // 商品ページに「カートを確認する」ボタンを注入
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
